import * as React from "react";
import * as SeparatorPrimitive from "@radix-ui/react-separator";

import { cn } from "../../lib/utils";

const Separator = React.forwardRef<
  React.ElementRef<typeof SeparatorPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root>
>(
  (
    { className, orientation = "horizontal", decorative = true, ...props },
    ref,
  ) => (
    <SeparatorPrimitive.Root
      ref={ref}
      decorative={decorative}
      orientation={orientation}
      className={cn(
        "shrink-0 bg-border",
        orientation === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
        className,
      )}
      {...props}
    />
  ),
);
Separator.displayName = SeparatorPrimitive.Root.displayName;

export { Separator };


/**
 * A horizontal separator line with optional text/content in the middle.
 * Uses Flexbox and Tailwind CSS for styling.
 */
export const SeparatorWithText = ({ children, className = '' }: any) => {
  return (
    // Main container using Flexbox to align items
    <div role="separator" className={`flex items-center ${className}`}>
      {/* Left line: grows to fill space, has height and background */}
      <div className="flex-grow border-t border-gray-300 dark:border-gray-600"></div>

      {/* Middle content: Uses padding for space, specific text styling */}
      {/* The 'flex-shrink-0' prevents the text container from shrinking if space is tight */}
      {children && (
        <span className="flex-shrink-0 px-4 text-sm text-gray-500 dark:text-gray-400">
          {children}
        </span>
      )}

      {/* Right line: grows to fill space, has height and background */}
      <div className="flex-grow border-t border-gray-300 dark:border-gray-600"></div>
    </div>
  );
};
